export default __webpack_public_path__ + "4705074f6ef937c496be3390e056f54a.png";